module.exports = __webpack_public_path__ + "img/Illustrations_Manage-Content@3x.9bc13a6e.png";